import restApi from "../../http.js";
import session from "@/services/session";

export default class InventoryApi {
  getProducts(params) {
    const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
    return restApi({
      method: "GET",
      url: `/products/inventory-levels?${queryString}`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      }
    });
  }
  setInventoryForProduct(id, data) {
    return restApi({
      method: "PATCH",
      url: `products/${id}/change-inventory`,
      data: data,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  setInventoryForProducts(products) {
    return restApi({
      method: "PATCH",
      url: `products/change-inventories`,
      data: {
        products : products
      },
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
}
